import { render, staticRenderFns } from "./ag_test_suite_setup_result_detail.vue?vue&type=template&id=48c7d0d6&scoped=true&"
import script from "./ag_test_suite_setup_result_detail.vue?vue&type=script&lang=ts&"
export * from "./ag_test_suite_setup_result_detail.vue?vue&type=script&lang=ts&"
import style0 from "./ag_test_suite_setup_result_detail.vue?vue&type=style&index=0&id=48c7d0d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7d0d6",
  null
  
)

export default component.exports